import firebase from 'firebase'
import 'firebase/firestore'

// firebase init goes here
const config = {
  apiKey: "AIzaSyCyJWN9XxlZyEVseR4LKC4CPwkub8h5u34",
  authDomain: "orbitist-exploration-platform.firebaseapp.com",
  databaseURL: "https://orbitist-exploration-platform.firebaseio.com",
  projectId: "orbitist-exploration-platform",
  storageBucket: "orbitist-exploration-platform.appspot.com",
  messagingSenderId: "722703778530"
}
firebase.initializeApp(config)

// firebase utils
const db = firebase.firestore()
const auth = firebase.auth()
const currentUser = auth.currentUser

// date issue fix according to firebase
const settings = {
	// timestampsInSnapshots: true
}
db.settings(settings)

// firebase collections
const usersCollection = db.collection('users')
const explorationsCollection = db.collection('explorations')
const pointsCollection = db.collection('points')

export {
    db,
    auth,
    currentUser,
    usersCollection,
    explorationsCollection,
    pointsCollection
  }



// WEBPACK FOOTER //
// ./src/firebaseConfig.js